export default __webpack_public_path__ + "static/media/gallery_00.d6fed6ab.jpg";